// extracted by mini-css-extract-plugin
export default {"closeButton":"MobileSearchBar_closeButton__8hLSS","input":"MobileSearchBar_input__YfzYj","inputContainer":"MobileSearchBar_inputContainer__qANL6"};